<template>
	<v-container fluid>
		<v-row dense>
			<v-col cols="12" md="12">
				<v-btn large class="primary" @click="getPolls">
					<v-icon>mdi-refresh</v-icon>
					Refresh
				</v-btn>
			</v-col>
			<v-col cols="12" md="6">
				<v-card v-if="poll">
					<v-card-title class="justify-center text-center">Poll # [{{ poll.id }} ]</v-card-title>
					<v-card-text>
						<v-simple-table v-for="(item,i) in sms.length" class="mb-4">
							<template v-slot:default>
								<thead>
								<tr>
									<td colspan="4">
										<h2>{{ sms[i].question }}</h2>
									</td>
								</tr>
								<tr>
									<th class="text-left">
										#
									</th>
									<th class="text-left">
										Candidate
									</th>
									<th class="text-left">
										Votes
									</th>
									<th class="text-left">
										Percentage %
									</th>
								</tr>
								</thead>
								<tbody>
								<tr
										v-for="(item,i) in sms[i].poll_options"
										:key="i"
								>
									<td>{{ i + 1 }}</td>
									<td> {{ item.option }}</td>
									<td>{{ item.votes }}</td>
									<td>
										{{
											((item.votes / sms[0].poll_options.map(bill => bill.votes).reduce((acc, bill) => bill + acc)) * 100).toFixed(2)
										}}
										%
									</td>
								</tr>
								<tr class="font-weight-bold">
									<td></td>
									<td>Total</td>
									<td>{{
											(sms[0].poll_options.map(bill => bill.votes).reduce((acc, bill) => bill + acc)).toFixed(2)
										}}
									</td>
									<td>100</td>
								</tr>
								</tbody>
							</template>
						</v-simple-table>
						<v-divider class="ma-3 green"/>
					</v-card-text>
				</v-card>
				<v-card v-else>You dont have any poll now</v-card>
			</v-col>
			<v-col cols="12" md="12">
				<v-card>
					<v-card-text>
						<h2>Live Poll Statistics</h2>
						<v-simple-table>
							<template v-slot:default>
								<thead>
								<tr>
									<th class="text-left">
										Mechanism
									</th>
									<th class="text-left">
										Questions
									</th>
									<th class="text-left">
										Sent
									</th>
									<th class="text-left">
										Responses
									</th>
									<th class="text-left">
										Response Percentage %
									</th>
								</tr>
								</thead>
								<tbody>
								<tr>
									<td>Ussd</td>
									<td>{{ poll.qCount }}</td>
									<td>{{ poll.cost }}</td>
									<td>{{
											(sms[0].poll_options.map(bill => bill.votes).reduce((acc, bill) => bill + acc)).toFixed(2)
										}}
									</td>
									<td>{{
											((sms[0].poll_options.map(bill => bill.votes).reduce((acc, bill) => bill + acc) / poll.cost) * 100).toFixed(2)
										}}
									</td>
								</tr>
								</tbody>
							</template>
						</v-simple-table>
						<v-divider class="ma-3 green"/>
						<v-row dense v-if="poll.level ==='constituency'">
							<v-col cols="12">
								Ward/School BreakDown
							</v-col>
							<v-col cols="12" md="6" v-for="(wardSummary,i) in wardSummaryData" class="">
								<poll-table :i="i" :ward-summary="wardSummary"/>
							</v-col>
						</v-row>
						<v-row dense v-if="poll.level ==='ward'">
							<v-col cols="12">
								Polling/Department Center Details
							</v-col>
							<v-col cols="12" md="6" v-for="(wardSummary,i) in pollingSummaryData" class="">
								<poll-table :i="i" :ward-summary="wardSummary"/>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import {getRequest} from "@/api/apirepository";
import PollTable from "@/components/widgets/tables/PollTable";

export default {
	name: "ClientViewDashboard",
	components: {PollTable},
	data: () => ({
		skill: 20,
		knowledge: 33,
		power: 78,
		sms: [],
		poll: null,
		constituencyData: [],
		wardData: [],
		wardSummaryData: [],
		pollingData: [],
		selectedPoll: [],
		pollingSummaryData: [],
		desserts: [
			{
				name: 'Ndindi Nyoro',
				number: 1,
				votes: 159,
				percent: 51,
			},
			{
				name: 'Others',
				number: 2,
				votes: 140,
				percent: 49,
			},
		]
	}),
	methods: {
		getPolls() {
			getRequest('pollResults', {
				params: {
					id: this.$store.state.user.id,
				}
			}).then(({data}) => {
				this.sms = data.questions;
				this.poll = data.poll;
				if (this.poll.level === 'county') {
					this.getConstituencyResultsPolls()
					this.getWardResultsPolls()
					this.getPollingStationResultsPolls()
				} else if (this.poll.level === 'constituency') {
					this.getWardResultsPolls()
					this.getQuestionFromVote()
					this.getQuestionFromPollingVote()
					this.getPollingStationResultsPolls()
				} else if (this.poll.level === 'ward') {
					// this.getWardResultsPolls()
					this.getQuestionFromVote()
					this.getQuestionFromPollingVote()
					this.getPollingStationResultsPolls()
				} else if (this.poll.level === 'pollingstation') {
					this.getPollingStationResultsPolls()
				}
			}).catch(e => {
				console.log(e)
			})
		},
		getWardResultsPolls() {
			getRequest('getResultsByWards', {
				params: {
					id: this.$store.state.user.id,
				}
			}).then(({data}) => {
				console.log(data)
			}).catch(e => {
				console.log(e)
			})
		},
		getConstituencyResultsPolls() {
			getRequest('getResultsByConstituencies', {
				params: {
					id: this.$store.state.user.id,
				}
			}).then(({data}) => {
				this.constituencyData = data.map(item => {
					return {
						...item,
						percent: ((item.count / this.sms[0].poll_options.map(bill => bill.votes).reduce((acc, bill) => bill + acc)) * 100).toFixed(2) + "%"
					}
				});
				// console.log(data)
			}).catch(e => {
				console.log(e)
			})
		},
		getQuestionFromVote() {
			getRequest('getQuestionFromVote', {
				params: {
					id: this.$store.state.user.id,
					pollId: this.$store.state.user.pollId,
				}
			}).then(({data}) => {
				this.wardSummaryData = data;
				// console.log(data)
			}).catch(e => {
				console.log(e)
			})
		},
		getQuestionFromPollingVote() {
			getRequest('getQuestionFromPollingVote', {
				params: {
					id: this.$store.state.user.id,
					pollId: this.$store.state.user.pollId,
				}
			}).then(({data}) => {
				this.pollingSummaryData = data;
				// console.log(data)
			}).catch(e => {
				console.log(e)
			})
		},
		getPollingStationResultsPolls() {
			getRequest('getResultsByPollingStations', {
				params: {
					id: this.$store.state.user.id,
				}
			}).then(({data}) => {
				this.pollingData = data.map(item => {
					return {
						...item,
						percent: ((item.count / this.sms[0].poll_options.map(bill => bill.votes).reduce((acc, bill) => bill + acc)) * 100).toFixed(2) + "%"
					}
				});
				// console.log(data)
			}).catch(e => {
				console.log(e)
			})
		}
	},
	created() {
		this.getPolls()
		this.getWardResultsPolls()
	}
}
</script>

<style scoped>

</style>